import * as React from "react"
import { IconProps } from "./types"

export const GiftIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="51.714"
    height="33.608"
    viewBox="0 0 51.714 33.608"
    {...props}
  >
    <g
      id="Raggruppa_857"
      data-name="Raggruppa 857"
      transform="translate(-341.816 -291.747)"
    >
      <g id="Raggruppa_611" data-name="Raggruppa 611">
        <path
          id="Tracciato_381"
          data-name="Tracciato 381"
          d="M386.955,324.105H349.132l-1.506-10.7a7.211,7.211,0,0,1,7.14-8.216h26.555a7.211,7.211,0,0,1,7.14,8.216Z"
          fill="none"
          stroke="#054d47"
          strokeWidth="2.5"
        />
        <g id="Raggruppa_609" data-name="Raggruppa 609">
          <g id="Raggruppa_606" data-name="Raggruppa 606">
            <g id="Raggruppa_605" data-name="Raggruppa 605">
              <path
                id="Tracciato_382"
                data-name="Tracciato 382"
                d="M367.959,304.379l2.189-6.248a3.819,3.819,0,0,1,6.354-1.388h0a3.818,3.818,0,0,1-1.6,6.292l-6.312,2A.509.509,0,0,1,367.959,304.379Z"
                fill="none"
                stroke="#054d47"
                strokeWidth="2.5"
              />
            </g>
          </g>
          <g id="Raggruppa_608" data-name="Raggruppa 608">
            <g id="Raggruppa_607" data-name="Raggruppa 607">
              <path
                id="Tracciato_383"
                data-name="Tracciato 383"
                d="M368.124,304.366l-2.184-6.235a3.82,3.82,0,0,0-6.355-1.388h0a3.819,3.819,0,0,0,1.6,6.292l6.3,1.994A.516.516,0,0,0,368.124,304.366Z"
                fill="none"
                stroke="#054d47"
                strokeWidth="2.5"
              />
            </g>
          </g>
        </g>
        <line
          id="Linea_21"
          data-name="Linea 21"
          y2="19.368"
          transform="translate(368.211 304.737)"
          fill="none"
          stroke="#054d47"
          strokeWidth="2.5"
        />
        <g id="Raggruppa_610" data-name="Raggruppa 610">
          <line
            id="Linea_22"
            data-name="Linea 22"
            x1="8.368"
            y2="6.375"
            transform="translate(359.676 305.136)"
            fill="none"
            stroke="#054d47"
            strokeWidth="2.5"
          />
          <line
            id="Linea_23"
            data-name="Linea 23"
            x2="8.368"
            y2="6.375"
            transform="translate(368.044 305.136)"
            fill="none"
            stroke="#054d47"
            strokeWidth="2.5"
          />
        </g>
        <line
          id="Linea_24"
          data-name="Linea 24"
          x2="39.725"
          transform="translate(348.157 317.182)"
          fill="none"
          stroke="#054d47"
          strokeWidth="2.5"
        />
      </g>
      <circle
        id="Ellisse_69"
        data-name="Ellisse 69"
        cx="1"
        cy="1"
        r="1"
        transform="translate(349.107 298.844)"
        fill="#054d47"
      />
      <circle
        id="Ellisse_70"
        data-name="Ellisse 70"
        cx="1"
        cy="1"
        r="1"
        transform="translate(351.107 291.844)"
        fill="#054d47"
      />
      <circle
        id="Ellisse_71"
        data-name="Ellisse 71"
        cx="0.813"
        cy="0.813"
        r="0.813"
        transform="translate(341.816 305.054)"
        fill="#054d47"
      />
      <circle
        id="Ellisse_72"
        data-name="Ellisse 72"
        cx="0.813"
        cy="0.813"
        r="0.813"
        transform="translate(391.902 305.868)"
        fill="#054d47"
      />
      <circle
        id="Ellisse_73"
        data-name="Ellisse 73"
        cx="1"
        cy="1"
        r="1"
        transform="translate(389.107 299.844)"
        fill="#054d47"
      />
      <rect
        id="Rettangolo_393"
        data-name="Rettangolo 393"
        width="2.828"
        height="2.828"
        transform="translate(385.517 291.747) rotate(65.534)"
        fill="#054d47"
      />
      <rect
        id="Rettangolo_394"
        data-name="Rettangolo 394"
        width="2.828"
        height="2.828"
        transform="matrix(0.92, 0.392, -0.392, 0.92, 344.07, 294.765)"
        fill="#054d47"
      />
    </g>
  </svg>
)
